import { createReducer, on, Action } from '@ngrx/store';
import * as JobLocationActions from './job-location.actions';
import * as QuoteDetailActions from 'src/admin-app/quotes/quote-detail/+state/quote-detail.actions';
import { Subdivision } from 'src/shared/api';

export const jobLocationFeatureKey = 'job-location';

export interface JobLocationState {
	isInitialized: boolean;
	error?: any;
	isLoading?: boolean;
	latlng?: { latitude: number; longitude: number };
	subdivision?: Subdivision;
}

export interface JobLocationPartialState {
	readonly [jobLocationFeatureKey]: JobLocationState;
}

export const initialState: JobLocationState = {
	isInitialized: false,
	// additional entity state properties
};

const jobLocationReducer = createReducer(
	initialState,
	on(JobLocationActions.pinDropped, (state, { latlng }) => ({
		...state,
		latlng,
	})),
	on(
		QuoteDetailActions.quoteLoadedFromApi,
		QuoteDetailActions.quoteLoadedFromStore,
		(state, { quote }) => ({
			...state,
			subdivision: quote.subdivision,
		})
	),
	on(
		QuoteDetailActions.railroadSelected,
		QuoteDetailActions.divisionSelected,
		(state) => ({
			...state,
			subdivision: undefined,
		})
	),
	on(JobLocationActions.locationSelected, (state, { address }) => ({
		...state,
		latlng: { latitude: address.lat, longitude: address.lon },
	})),
	on(JobLocationActions.jobLocationDestroyed, (state) => ({
		...state,
		error: undefined,
		isLoading: undefined,
		listMessage: undefined,
		subdivision: undefined,
		latlng: undefined,
		isInitialized: false,
	}))
);

export function reducer(state: JobLocationState | undefined, action: Action) {
	return jobLocationReducer(state, action);
}
